import { useRootFontSize } from './useRootFontSize';

/**
 * 将 rem 转换为 px, 有些 antd 组件属性不支持接受 rem 单位，所有需要先换成 px 再传入。
 * @param rem
 * @returns
 */
export const useRem2Px = (rem: number) => {
  const rootFontSize = useRootFontSize();

  return rootFontSize * rem;
};
